/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from "react"
import { Menu } from "@mantine/core"

interface MentionListProps {
    // eslint-disable-next-line react/no-unused-prop-types
    items?: string[]
    command: (arg: object) => void
}

// https://tiptap.dev/api/nodes/mention#usage
export const MentionList = forwardRef(({ items, command }: MentionListProps, ref) => {
    const selectItem = (index) => {
        const item = items[index]

        if (item) {
            command({ id: item })
        }
    }

    const renderMembers = () =>
        items.map((item, index) => (
            <Menu.Item key={index} onClick={() => selectItem(index)}>
                {item}
            </Menu.Item>
        ))

    if (items?.length) {
        return <span className="mention-select">{<Menu opened={true}>{renderMembers()}</Menu>}</span>
    }
})
